import React, {Component} from "react";

import * as types from "../../../../constants/componentTypes";

import ModuleModal from "../global/modal/ModuleModal";
import VersionModal from "../global/modal/VersionModal";
import DatabaseListModal from "../global/modal/DatabaseListModal";
import AddServerModal from "./modal/AddServerModal";
import EditServerModal from "./modal/EditServerModal";
import NoteModal from "./modal/NoteModal";
import RestartRedlikeModal from "./modal/RestartRedlikeModal";
import RebootPCModal from "./modal/RebootPCModal";
import DatePickerModal from "./modal/DatePickerModal";
import LoadHistoryOrderModal from "./modal/LoadHistoryOrderModal";
import ConfirmCustomerModal from "./modal/ConfirmCustomerModal";
import OrderNotificationModal from "../../../../containers/modal/OrderNotificationModal";
import DebugModal from "../../../global/modal/DebugModal";
import WarningCustomerModal from "./modal/WarningCustomerModal";
import WarningMissingDataModal from "./modal/WarningMissingDataModal";
import ModifiedOrderModal from "./modal/ModifiedOrderModal";

export default class Modal extends Component {
    render() {
        switch (this.props.type) {
            case types.INTERGAMMA_MODULE_MODAL:
                return <ModuleModal {...this.props} />;
            case types.INTERGAMMA_SW_VERSIONS_MODAL:
                return <VersionModal {...this.props} />;
            case types.INTERGAMMA_DATABASE_LIST_MODAL:
                return <DatabaseListModal {...this.props} />;
            case types.INTERGAMMA_ADD_SERVER_MODAL:
                return <AddServerModal {...this.props} />;
            case types.INTERGAMMA_EDIT_SERVER_MODAL:
                return <EditServerModal {...this.props} />;
            case types.INTERGAMMA_NOTE_MODAL:
                return <NoteModal {...this.props} />;
            case types.INTERGAMMA_RESTART_REDLIKE_MODAL:
                return <RestartRedlikeModal {...this.props} />;
            case types.INTERGAMMA_REBOOT_PC_MODAL:
                return <RebootPCModal {...this.props} />;
            case types.INTERGAMA_DATE_PICKER_MODAL:
                return <DatePickerModal {...this.props} />;
            case types.INTERGAMMA_LOAD_HISTORY_ORDER_MODAL:
                return <LoadHistoryOrderModal {...this.props} />;
            case types.INTERGAMMA_CONFIRM_CUSTOMER_MODAL:
                return <ConfirmCustomerModal {...this.props} />;
            case types.ORDER_NOTIFICATION_MODAL:
                return <OrderNotificationModal {...this.props} />;
            case types.INTERGAMMA_WARNING_CUSTOMER_MODAL:
                return <WarningCustomerModal {...this.props} />;
            case types.INTERGAMMA_WARNING_MISSING_DATA_MODAL:
                return <WarningMissingDataModal {...this.props} />;
            case types.DEBUG_MODAL:
                return <DebugModal {...this.props} />;
            case types.MODIFIED_ORDER_MODAL:
                return <ModifiedOrderModal {...this.props} />;
            default:
                return <div />;
        }
    }
}
